export const integrationDefaults = {
    provider: "", // 'evolution', 'openai', 'gemini'
    name: "",
    isActive: true,
    config: {}
};

export const evolutionApiDefaults = {
    apiUrl: "",
    apiKey: "",
    instanceName: "",
    webhookUrl: ""
};

export const openAiDefaults = {
    apiKey: "",
    organizationId: "",
    defaultModel: "gpt-4o",
    systemPrompt: "Você é um assistente prestativo."
};

export const geminiDefaults = {
    apiKey: "",
    defaultModel: "gemini-1.5-pro",
    systemPrompt: "Você é um assistente prestativo."
};
